import React, { useEffect, useState } from "react";
import { NavLink, Link, useLocation } from "react-router-dom";

export default function Header() {
  const [open, setOpen] = useState(false);
  const { pathname } = useLocation();

  // Close mobile menu on route change
  useEffect(() => {
    setOpen(false);
  }, [pathname]);

  return (
    <header className="header" role="banner">
      <div className="container header-inner">
        <div className="brand">
          <Link to="/" className="brand-link" aria-label="Go to homepage">
            <span className="brand-mark" aria-hidden="true">✦</span>
            <span className="brand-name">Zachary Kalmbach</span>
          </Link>
        </div>

        <nav id="primary-navigation" className={`nav ${open ? "is-open" : ""}`} aria-label="Primary">
          <ul className="nav-list">
            <li>
              <NavLink to="/" end className="nav-link">Home</NavLink>
            </li>
            <li>
              <NavLink to="/portfolio" className="nav-link">Portfolio</NavLink>
            </li>
            <li>
              <NavLink to="/services" className="nav-link">Services & Pricing</NavLink>
            </li>
            <li>
              <NavLink to="/contact" className="nav-link">Contact</NavLink>
            </li>
          </ul>
          <Link to="/contact" className="btn-primary header-cta">
            Check Availability
          </Link>
        </nav>

        <button
          className="menu-toggle"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
          aria-controls="primary-navigation"
          onClick={() => setOpen((o) => !o)}
        >
          <span className="menu-icon" aria-hidden="true" />
        </button>
      </div>
    </header>
  );
}